import { pino } from 'pino'

export const logger = pino({
  level: 'trace',
  transport: {
    target: 'pino-pretty',
    options: {
      translateTime: 'SYS:yyyy-mm-dd HH:MM:ss',
      ignore: 'pid,hostname',
      singleLine: true // prevents context objects to be outputted
    }
  }
})
